import { useQueryClient } from '@tanstack/react-query';

import { withLimitToBE } from '@/react/hooks/useLimitToBE';
import { queryKeys } from '@/react/portainer/environments/update-schedules/queries/query-keys';
import {
  FeatureFlag,
  useFeatureFlag,
} from '@/react/portainer/feature-flags/useFeatureFlag';

import { PageHeader } from '@@/PageHeader';

import { BetaAlert } from '../common/BetaAlert';

import { UpdateSchedulesDatatable as OldUpdateSchedulesDatatable } from './UpdateSchedulesDatatableOld';

export default withLimitToBE(ListView);

export function ListView() {
  const featureFlagQuery = useFeatureFlag(FeatureFlag.NEW_UPDATE_SCHEDULES);

  if (featureFlagQuery.data) {
    return NewListView();
  }

  return OldListView();
}

function OldListView() {
  const queryClient = useQueryClient();

  return (
    <>
      <PageHeader
        title="Update & Rollback"
        breadcrumbs="Update and rollback"
        reload
        onReload={() => queryClient.invalidateQueries(queryKeys.base())}
      />

      <BetaAlert
        className="mb-2 ml-[15px]"
        message="Beta feature - currently limited to standalone Linux edge devices."
      />

      <OldUpdateSchedulesDatatable />
    </>
  );
}

function NewListView() {
  return <>environments list</>;
}
